import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../utils/formatters';

/**
 * CompactMetricItem - Displays a single metric in a condensed format
 * Used in mobile view for displaying financial metrics
 */
const CompactMetricItem = ({ title, value, currency = 'BRL', isHighlighted = false }) => (
  <Box sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1.5,
    px: 2,
    bgcolor: isHighlighted ? 'rgba(29, 165, 122, 0.05)' : 'transparent',
  }}>
    <Typography variant="body2" color="text.secondary">
      {title}
    </Typography>
    <Typography
      variant="body1"
      fontWeight={isHighlighted ? '600' : 'medium'}
      color={isHighlighted ? 'success.main' : 'text.primary'}
    >
      {formatCurrency(value, currency)}
    </Typography>
  </Box>
);

CompactMetricItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  currency: PropTypes.string,
  isHighlighted: PropTypes.bool
};

export default CompactMetricItem;